export default "__VITE_ASSET__BGv2A8aY__"